import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { businessInfo, images } from "../mock";

// Cinematic mid-page CTA strip with parallax-ish image
const CTAStrip = () => {
  return (
    <section
      className="relative py-16 md:py-20 overflow-hidden"
      aria-label="Call Claim Beast"
    >
      <div className="absolute inset-0">
        <img
          src={images.storm}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/50" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 flex flex-col lg:flex-row items-center justify-between gap-8">
        <div>
          <div className="text-[#E11D26] text-xs font-bold tracking-[0.3em] uppercase">
            Storm Damage? Denied Claim?
          </div>
          <h3
            className="mt-3 text-white text-3xl sm:text-4xl md:text-5xl font-black uppercase leading-[0.95]"
            style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
          >
            Don't Settle. <span className="text-[#E11D26]">Fight Back.</span>
          </h3>
          <p className="mt-3 text-white/75 max-w-xl">
            Tampa Bay public adjusters available 24/7. Free claim review. No
            payout, no fee. Ever.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
          <a
            href={`tel:${businessInfo.phoneRaw}`}
            className="inline-flex items-center justify-center gap-2 bg-white text-black hover:bg-white/90 font-bold uppercase tracking-wider px-7 py-4 transition-colors"
          >
            <Phone className="h-4 w-4" />
            <span className="text-sm">{businessInfo.phone}</span>
          </a>
          <a
            href="#contact"
            className="group inline-flex items-center justify-center gap-2 bg-[#E11D26] hover:bg-[#c11820] text-white font-bold uppercase tracking-wider px-7 py-4 transition-colors"
          >
            <span className="text-sm">Free Claim Review</span>
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTAStrip;
